import React from "react";

const FaceBookTrueIcon = () => {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17323_9422)">
        <path
          d="M24 12C24 5.37264 18.6274 0 12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12H24Z"
          fill="#0866FF"
        />
        <path
          d="M16.6988 15.6701L17.3722 12.0029H13.4525V10.706C13.4525 8.76819 14.2128 8.02275 16.1804 8.02275C16.7914 8.02275 17.2834 8.03763 17.5666 8.06739V4.74339C17.03 4.59411 15.7181 4.44531 14.9578 4.44531C10.9479 4.44531 9.0994 6.33843 9.0994 10.4228V12.0029H6.625V15.6701H9.0994V23.6496C10.0277 23.88 10.9988 24.0029 11.9981 24.0029C12.4901 24.0029 12.9754 23.9727 13.452 23.9151V15.6701H16.6983H16.6988Z"
          fill="white"
        />
      </g>
      <rect x={15} y={14} width={18} height={18} rx={9} fill="#23A26D" />
      <path
        d="M22.4143 24.9722L27.8862 19.6871C28.0154 19.5624 28.1687 19.5 28.3463 19.5C28.5238 19.5 28.6772 19.5624 28.8063 19.6871C28.9354 19.8118 29 19.9599 29 20.1314C29 20.3029 28.9354 20.451 28.8063 20.5757L22.8662 26.3129C22.7371 26.4376 22.5864 26.5 22.4143 26.5C22.2421 26.5 22.0914 26.4376 21.9623 26.3129L19.186 23.6314C19.0568 23.5067 18.9949 23.3586 19.0003 23.1871C19.0057 23.0156 19.073 22.8675 19.2021 22.7428C19.3312 22.618 19.4846 22.5557 19.6621 22.5557C19.8397 22.5557 19.993 22.618 20.1222 22.7428L22.4143 24.9722Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_17323_9422">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FaceBookTrueIcon;
